import React from 'react';
import { Typography } from '@mui/material';

/**
 * ReactMarkdown에서 사용할 컴포넌트 설정
 */
export const markdownComponents = {
  h1: ({ node, ...props }) => (
    <Typography {...props} variant="h6" sx={{ fontSize: 15, fontWeight: 600, color: '#1976d2', mt: 2, mb: 1 }} />
  ),
  h2: ({ node, ...props }) => (
    <Typography {...props} variant="h6" sx={{ fontSize: 15, fontWeight: 600, color: '#1976d2', mt: 2, mb: 1 }} />
  ),
  h3: ({ node, ...props }) => (
    <Typography {...props} variant="h6" sx={{ fontSize: 15, fontWeight: 600, color: '#1976d2', mt: 2, mb: 1 }} />
  ),
  p: ({ node, ...props }) => (
    <Typography {...props} sx={{ color: '#222', fontSize: 15, lineHeight: 1.7, mb: 1, whiteSpace: 'pre-line' }} />
  ),
  li: ({ node, ...props }) => (
    <li style={{ marginLeft: 18, marginBottom: 4, color: '#444', fontSize: 15, lineHeight: 1.6 }}>
      <Typography {...props} component="span" sx={{ fontSize: 15, color: '#444', lineHeight: 1.6 }} />
    </li>
  ),
  strong: ({ node, ...props }) => (
    <Typography {...props} component="span" sx={{ fontWeight: 700, color: '#1976d2', fontSize: 15 }} />
  ),
}; 